import axios from 'axios';

export const getCompanies = async (userId) => {
  const { data } = await axios.get(`/users/${userId}/multidomain-companies`);
  return data;
};
